// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textArea_uMvVa {
  font: normal 14px/22px Inter;
  color: var( --color-base700 );
  border: 1px solid var( --color-base200 );
  padding: var( --size-medium );
  outline: none;
  transition: background-color 0.2s,color 0.2s,transform 0.2s;
  border-radius: 4px;
  background-color: var( --color-white );
}
.textArea_uMvVa:focus {
  box-shadow: 0 1px 3px var( --color-shadowBase );
  border-top-color: var( --color-brand300 );
  border-left-color: var( --color-brand300 );
  border-right-color: var( --color-brand300 );
  border-bottom-color: var( --color-brand300 );
}
.textArea_uMvVa:hover {
  border-top-color: var( --color-brand300 );
  border-left-color: var( --color-brand300 );
  border-right-color: var( --color-brand300 );
  border-bottom-color: var( --color-brand300 );
}
.textArea_uMvVa[readonly] {
  font: normal 400 16px/1.2 Inter;
  color: var( --color-base300 );
  background: linear-gradient(var( --color-base100 ), var( --color-base100 )), var( --color-base100 );
  border-top-color: var( --color-base300 );
  border-left-color: var( --color-base300 );
  border-right-color: var( --color-base300 );
  border-bottom-color: var( --color-base300 );
}
.textArea_uMvVa[data-error=true] {
  border-top-color: var( --color-danger500 );
  border-left-color: var( --color-danger500 );
  border-right-color: var( --color-danger500 );
  border-bottom-color: var( --color-danger500 );
}
.textArea_uMvVa::placeholder {
  font: italic 400 var( --size-inputMedium )/1.2 Inter;
  color: var( --color-base300 );
}`, "",{"version":3,"sources":["webpack://./src/theme/TextArea.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;EACxC,6BAA6B;EAC7B,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,mGAAmG;EACnG,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,oDAAoD;EACpD,6BAA6B;AAC/B","sourcesContent":[".textArea {\n  font: normal 14px/22px Inter;\n  color: var( --color-base700 );\n  border: 1px solid var( --color-base200 );\n  padding: var( --size-medium );\n  outline: none;\n  transition: background-color 0.2s,color 0.2s,transform 0.2s;\n  border-radius: 4px;\n  background-color: var( --color-white );\n}\n.textArea:focus {\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  border-top-color: var( --color-brand300 );\n  border-left-color: var( --color-brand300 );\n  border-right-color: var( --color-brand300 );\n  border-bottom-color: var( --color-brand300 );\n}\n.textArea:hover {\n  border-top-color: var( --color-brand300 );\n  border-left-color: var( --color-brand300 );\n  border-right-color: var( --color-brand300 );\n  border-bottom-color: var( --color-brand300 );\n}\n.textArea[readonly] {\n  font: normal 400 16px/1.2 Inter;\n  color: var( --color-base300 );\n  background: linear-gradient(var( --color-base100 ), var( --color-base100 )), var( --color-base100 );\n  border-top-color: var( --color-base300 );\n  border-left-color: var( --color-base300 );\n  border-right-color: var( --color-base300 );\n  border-bottom-color: var( --color-base300 );\n}\n.textArea[data-error=true] {\n  border-top-color: var( --color-danger500 );\n  border-left-color: var( --color-danger500 );\n  border-right-color: var( --color-danger500 );\n  border-bottom-color: var( --color-danger500 );\n}\n.textArea::placeholder {\n  font: italic 400 var( --size-inputMedium )/1.2 Inter;\n  color: var( --color-base300 );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textArea": `textArea_uMvVa`
};
export default ___CSS_LOADER_EXPORT___;
